import Pagination from '@/components/pagination/index.vue';

import { getPageIndex } from '@/utils/common.js';
import { mapGetters } from 'vuex';
import Service from '../service.js';

export default {
  components: {
    Pagination
  },
  data() {
    return {
      total: 0,
      tableList: [],
      pageSize: 10,
      pageNum: 1,
      dialogFormVisible: false,
      dialogFormData: {
        id: '',
        userInspectionStatus: 1,
        userInspectionRemark: '',
        userInspectionPhotos: []
      },
      rules: {
        userInspectionStatus: [
          { required: true, message: '请选择验收状态', trigger: 'change' }
        ],
        userInspectionRemark: [
          { required: true, message: '请输入不通过原因', trigger: 'blur' }
        ],
        userInspectionPhotos: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      // pageNum: 'pageNum',
      // pageSize: 'pageSize',
    }),
    tableEditWidth () {
      let width = 80;
      if(this.tableList.some((e) => {return e.status === '060';})){
        width = 170;
      }
      return width;
    }
  },
  created() {
    this.getTableList();
  },
  methods: {

    // 序号计算
    indexMethod(index) {
      return getPageIndex(this.pageNum, this.pageSize, index);
    },

    // 获取表格数据
    getTableList(page) {
      if (page && page.pageNo && page.pageSize) {
        this.pageNum = page.pageNo;
        this.pageSize = page.pageSize;
      }
      const query = {
      };
      query.limit = this.pageSize;
      query.skip = (this.pageNum - 1) * this.pageSize;
      this.total = 0;
      this.tableList = [];
      Service.getOrderList(query).then(res => {
        this.total = res.total;
        this.tableList = res.result;
      });
    },

    // 交付订单弹窗
    showDialig(item) {
      this.dialogFormVisible = true;
      this.dialogFormData.id = item._id;
    },

    showSubmitInspect() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$confirm('您确认提交验收结果吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 验收
            this.submitInspect();
          }).catch(() => {
          });
        }
      });
    },

    submitInspect() {
      const formData = JSON.parse(JSON.stringify(this.dialogFormData));
      if(formData.userInspectionStatus === 1) {
        delete formData.userInspectionRemark;
      }
      Service.inspectTrusteeship(formData).then((res) => {
        if(res) {
          this.dialogFormVisible = false;
          this.$successMessage('操作成功');
          this.getTableList();
        }
      }, (error) => {
        this.dialogFormVisible = false;
        const reason = error.data && error.data.reason;
        if (reason) {
          this.$alert(reason, '提示', {
            confirmButtonText: '确定',
            callback: () => {
            }
          });
          return;
        }
      });
    },

    toDetail(item) {
      this.$router.push('/person-center/orders/finance/details?id=' + item._id);
    },
    uploadImage (event) {
      console.log(event);
      if (event.length > 0) {
        this.dialogFormData.userInspectionPhotos = event;
      } else {
        this.dialogFormData.userInspectionPhotos = [];
      }
    },
    updateStatus(value) {
      if(value === 2) {
        this.dialogFormData.userInspectionPhotos = [];
      }
    }
  }
};
